import { useMemo } from 'react'

import { useAuthConfig } from './useAuthConfig'

const DEFAULT_PORTAL: Record<string, boolean> = {
  'nav.home': true,
  'nav.works': true,
}

/** 租户 C 端门户显隐(来自 GET /auth/config.portal) */
export function usePortalVisibility() {
  const { config, loading, error, reload } = useAuthConfig()

  const portal = useMemo(
    () => ({ ...DEFAULT_PORTAL, ...config?.portal }),
    [config?.portal],
  )

  const isPortalEnabled = (key: string) => portal[key] !== false

  return { portal, isPortalEnabled, loading, error, reload }
}
